(() => {
 const group = document.querySelector('.glass-nav-categories');
 if (!group) return;
 const toggle = group.querySelector('.glass-nav-toggle');
 const panel = group.querySelector('.glass-nav-panel');
 const link = group.querySelector('.glass-nav-category-link');
 const mouse = matchMedia('(hover:hover) and (pointer:fine)');
 let leaveTimer;
 function setOpen(open) {
   clearTimeout(leaveTimer);
   panel.hidden = !open;
   toggle.setAttribute('aria-expanded', String(open));
 }
 toggle.addEventListener('click', () => setOpen(panel.hidden));
 group.addEventListener('pointerenter', event => {
   if (event.pointerType === 'mouse' && mouse.matches) setOpen(true);
 });
 group.addEventListener('pointerleave', () => {
   leaveTimer = setTimeout(() => {
     if (!group.contains(document.activeElement)) setOpen(false);
   }, 180);
 });
 group.addEventListener('focusout', () => {
   setTimeout(() => { if (!group.contains(document.activeElement)) setOpen(false); }, 0);
 });
 link.addEventListener('keydown', event => {
   if (event.key === 'ArrowDown') {
     event.preventDefault(); setOpen(true);
     panel.querySelector('a')?.focus();
   }
 });
 document.addEventListener('keydown', event => {
   if (event.key === 'Escape' && !panel.hidden) {
     event.preventDefault(); setOpen(false); toggle.focus();
   }
 });
 document.addEventListener('pointerdown', event => {
   if (!group.contains(event.target)) setOpen(false);
 }, {passive:true});
 document.querySelector('#menu-toggle')?.addEventListener('click', () => setOpen(false));
})();